const regionDisplayOptions = [
  { value: 'state', label: 'States' },
  { value: 'metro', label: 'States + Metro Areas' },
  { value: 'zip3', label: 'State + Zip 3' },
]

export default regionDisplayOptions
